<template>
    <div>
        <!-- Stepper -->
        <section>
            <div class="centric-hold-80">
                <div class="wrapp-rt2">
                    <div class="booking-steps">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12"><div class="date-time-hold"><div class="completed-stage">1</div> Select a Service</div></div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 no-pad"><div class="date-time-hold"><div class="completed-stage-deactive">2</div> Choose Date and Time</div></div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 no-pad"><div class="date-time-hold"><div class="completed-stage-deactive">3</div> Personal Details</div></div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 no-pad"><div class="date-time-hold no-border"><div class="completed-stage-deactive">4</div> Complete your Booking</div></div>
                        </div>
                    </div>			
                </div>
            </div>
        </section>
        <!-- Stepper ends -->
    </div>
</template>

<script>
export default {
  name: "Stepper"
};
</script>

<style>
</style>
